module.exports = __webpack_public_path__ + "devfont.svg?d67010e84c379c54a42d4c9f5c38cf9e";